import { useEffect } from 'react';
import { pageStyles } from '@/styles/sharedStyles';

interface CompleteProps {
  stepData?: any;
  flowType?: 'one-off' | 'subscription';
  bookingData?: any;
  variant?: 'form-complete' | 'call-booked';
}

export function Complete({ stepData, flowType = 'one-off', bookingData, variant = 'form-complete' }: CompleteProps) {
  const isCallBooked = variant === 'call-booked';
  
  // Prevent back navigation after successful completion
  // Allow page refresh/exit since flow is complete and there's no unsaved data
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      // Prevent going back by pushing the current state again
      // This prevents users from navigating back to the flow steps which could cause conflicts
      window.history.pushState(null, '', window.location.pathname + window.location.search);
    };

    // Add a history entry to prevent back navigation
    window.history.pushState(null, '', window.location.pathname + window.location.search);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  
  return (
    <div className="max-w-2xl w-full mx-auto bg-white rounded-3xl shadow-sm p-12 text-center">
      <div className="mb-8">
        <div className="mx-auto w-20 h-20 rounded-full bg-green-light/20 flex items-center justify-center">
          <svg className="w-10 h-10 text-green-medium" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>

      <h1 className={`${pageStyles.title} mb-6`}>
        {isCallBooked ? 'Your call is booked' : `Your gifts are in good hands—Birdie's on it!`}
      </h1>

      <p className="text-gray-600 max-w-lg mx-auto leading-relaxed mb-8">
        We do all the work. You take all the credit. Consider it done!
      </p>

      {isCallBooked ? (
        <div className="text-purple-medium font-bold text-lg">
          Call scheduled / Calendly
        </div>
      ) : (
        <div className="bg-green-light/10 rounded-2xl p-8">
          <h3 className="text-2xl font-semibold text-purple-medium">Thank you!</h3>
        </div>
      )}
    </div>
  );
}